import React, {useRef, useState} from "react";
import styled from "styled-components";

import { withNamespaces } from 'react-i18next';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: ${({width = '100%'}) => `${width}`};
    border: 2px solid ${({borderColor = 'rgba(61, 0, 127, 0.24)'}) => borderColor};
    border-radius: ${({borderRadius = '20px'}) => borderRadius};
    padding: ${({padding = '24px 1px 1px 1px'}) => padding};

    h1 {
      margin-bottom: 8px;
      text-transform: uppercase;
      font-weight: 900;
    }

    h2 {
      margin: 0 16px;
      text-align: center;
      font-weight: 700;
      opacity: .8;
    }

    .select-currencies {
      text-align-last:center;
      text-align: center;
      background: transparent;
      background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
      background-repeat: no-repeat;
      background-position-x: 95%;
      background-position-y: 4.5px;
      margin-top: 16px;
      margin-bottom: 24px;
      width: 75%;
      min-width: 184px;
      text-align: center;
      -webkit-appearance: none;
      -moz-appearance: none;
      padding: 8px 24px;
      border: 2px solid ${({invertColor = 'rgba(61, 0, 127, 0.24)'}) => invertColor};
      border-radius: ${({borderRadius = '20px'}) => borderRadius};
    }
    
    .price-wrapper{
        display: flex;
        flex-wrap: wrap;
   
        width: 100%;
        align-items: center;
        justify-content: center;
       
       .definePrice {
          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;
          cursor: pointer;
          height: 35px;
          font-size: 20px;
          font-weight: 700;
          color:  ${({invertColor = 'rgba(61, 0, 127, 0.38)'}) => invertColor} !important;
          background: ${({color = '#EFE6F5'}) => color} !important;
          box-shadow: none !important;
          width: 33.33%;
          border: 1px solid ${({invertColor = 'white'}) => invertColor} !important;
          transition: .2s;
       }

       .definePrice:hover {
          border: 1px solid ${({invertColor = '#3D007F'}) => invertColor};
       }

      .selected{
        border: 1px solid ${({color = '#3D007F'}) => color} !important;
        color: ${({color = '#3D007F'}) => color} !important;
        background: ${({invertColor = '#EFE6F5'}) => invertColor} !important;
      }

        #root .globalContent .donation-module {
          border: 2px solid ${({borderColor = '#3D007F'}) => borderColor} !important;
          width: 100% !important;
        }

       .custom-value{
        width: 66.66%;
        height: 35px;
        background: ${({color = '#EFE6F5'}) => color};
        border: 1px solid ${({invertColor = 'white'}) => invertColor};
        padding: 14px 16px;
        font-size: 20px; 
        font-weight: 700;
        color: ${({invertColor = '#3D007F'}) => invertColor};
        text-align: center;
       }

       .custom-value::placeholder {
          color: ${({invertColor = '#333'}) => invertColor};
          font-size: 14px;
          font-weight: normal;
       }

       

       .custom-value::-webkit-outer-spin-button,
       .custom-value::-webkit-inner-spin-button {
         -webkit-appearance: none;
         margin: 0;
       }

       /* Firefox */
       .custom-value[type=number] {
         -moz-appearance: textfield;
       }
       
       padding-bottom: 1fpx;
    }
    
     button{
        padding: ${({padding = '20px', buttonPadding = '12px 40px'}) => buttonPadding || padding};
        background: ${({color = '#19FF9F'}) => color};
        color: ${({invertColor = 'black'}) => invertColor};
        border-radius: ${({borderRadius = '20px'}) => borderRadius};
        font-weight: 700;
        cursor: pointer;
      }
        
      button:disabled,
      button[disabled]{
          opacity: 0.5;
          cursor: default;
      }

      .setup-price {
        width: 100%;
        padding: 24px 0;
        background: ${({btnbackcolor = '#EFE6F5'}) => btnbackcolor};
        border-radius: ${({borderRadius = '0 0 20px 20px'}) => borderRadius};
        margin: 0 2px;
        display: flex;
        justify-content: center;

        button {
          width: fit-content;
        }
      }
  
  .confirm-title {
    margin: 24px 0 0;
    font-size: 12px;
    font-weight: 500;
    color: ${({color = 'black'}) => color};
    opacity: .8
  }
  
  .confirm-content {
    border-radius: ${({borderRadius = '0 0 20px 20px'}) => borderRadius};
    background: ${({btnbackcolor = '#EFE6F5'}) => btnbackcolor};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px 0;
    box-sizing: border-box;
    width: 100%;

    h1 {
      color: ${({color = '#3D007F'}) => color};
      font-size: 48px;
      margin: 20px 0 45px;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      padding: 0 48px;
      font-weight: normal;
    }
    
    h1 span {
      padding-right: 5px;
      padding-top: 5px;
      font-size: 60%;
      vertical-align: super;
    }


    .hide-preview {
      background: none;
      border-radius: 0;
      margin: 16px 0 0 0;
      padding: 0;
      font-size: 12px;
      font-weight: 500;
      border-bottom: 1px solid ${({color = '#EF42FF'}) => color};
      color: ${({color = '#EF42FF'}) => color};
    }
  }
`
const reduceOptions = (acc, val) => {
    if(Array.isArray(val) && val.length === 3){
        const [value, label, char] = val;
        return [...acc, {value, label, char}]
    }
    return acc;
};

const DonationForm = ({
  t,
  title = t("donation_form_title"),
  subtitle = t("donation_form_subtitle"),
  currencies = [
    ['eur', t("curr_eur"), '€'],
    ['usd', t("curr_usd"), '$'],
    ['rub', t("curr_rub"), '₽'],
    ['gbp', t("curr_gbp"), '£'],
    ['chf', t("curr_chf"), '₣'],
    ['aud', t("curr_aud"), 'AUD'],
    ['cad', t("curr_cad"), 'CAD']
  ],
  customPriceLabel = t("donation_form_customPriceLabel"),
  submit = t("donation_form_submit"),
  confirmTitle = t('confirm_title'),
  confirmButtonSubmit = t('confirm_button_submit'),
  confirmButtonSubmitLoading = t('confirm_button_submit_loading'),
  confirmButtonChangeValue = t('confirm_button_change_value'),
  definedPrices = [10, 25, 50, 75, 100, 250, 500],
  minimalPrice = 5,
  onPriceSubmit = () => null,
  ...props}) => {
    const [donation, setDonation] = useState(0);
    const currenciesOptions = currencies.reduce(reduceOptions, [])
    const [currency, setCurrency] = useState(currenciesOptions[0].value);
    const [currencyChar, setCurrencyChar] = useState(currenciesOptions[0].char);
    const [viewPreview, setViewPreview] = useState(false);
    const inputRef = useRef();
    const isSubmit = !donation || donation < minimalPrice;
    const [loading, setLoading] = useState(false);

    const onChangeCurrencyList = (e) => {
      const value = e.target.value.split("-")
      setCurrency(value[0]);
      setCurrencyChar(value[1]);
    }

    const onSetDontation = (e) => {
      setDonation(e.target.value);
      document.getElementById("custom-price").value = '';
    }

    document.onkeydown = function(event) {
      const keyCode = event ? (event.which ? event.which : event.keyCode) : event.keyCode;
      if(keyCode === 13) {
          if (!isSubmit) {
            if (viewPreview) {
              onPriceSubmit({donation, currency});
            } else {
              setViewPreview(true);
            }
          }
      }
    }

    return (
        <Wrapper className={'donation-module'} {...props}>
            <h1>{title}</h1>
            <h2>{subtitle}</h2>
            {viewPreview &&
              <React.Fragment>
                <span className={'confirm-title'}>{confirmTitle}</span>
                <div className={'confirm-content'}>
                  <h1><span>{currencyChar}</span>{donation}</h1>
                  <button disabled={loading} className={'btn confirm-btn'} onClick={() => {
                    setLoading(true);
                    onPriceSubmit({donation, currency})
                  }}>
                    <span>{loading ? confirmButtonSubmitLoading : confirmButtonSubmit}</span>
                  </button>
                  <button disabled={loading} className={'hide-preview'} onClick={() => setViewPreview(false)}>
                    {confirmButtonChangeValue}
                  </button>
                </div>
              </React.Fragment>
            }
            {!viewPreview &&
              <React.Fragment>
                <select
                  className={'select-currencies'}
                  onChange={onChangeCurrencyList}
                >
                    {currenciesOptions.map((cur, index) => {
                      return (
                        <option
                          selected={cur.value === currency}
                          key={index}
                          value={`${cur.value}-${cur.char}`}
                        >
                          {cur.label}
                        </option>
                      )
                    })}
                  </select>
                <div className={'price-wrapper'}>
                    {definedPrices.map(value => {
                        const selected = Number(value) === Number(donation) && 'selected';
                        return (
                          <input
                              key={value} onClick={(e) => onSetDontation(e)}
                              className={`definePrice ${selected}`} type={'button'} value={value}
                          />
                        )
                    })}
                    <input
                      id={'custom-price'}
                      className={'custom-value'}
                      type={'number'}
                      onChange={e => setDonation(e.target.value)}
                      ref={inputRef}
                      placeholder={customPriceLabel}
                    />
                </div>
                <div className={`setup-price setup a1`}>
                  <button disabled={isSubmit || loading} className={'btn confirm-btn'} onClick={() => setViewPreview(true)}>
                    <span>{submit}</span>
                  </button>
                </div>
              </React.Fragment>
            }
        </Wrapper>

    )
};

export default withNamespaces()(DonationForm);
